<template>
    <MeetingDetailsBlock
        iconName="external-link"
        :title="title"
    >
        <MeetingLocationLink
            v-if="meeting"
            :locationData="meeting.locationData"
            :locationType="meeting.locationType"
        />
        <span v-else> - </span>
    </MeetingDetailsBlock>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'
    import Meeting from '@/App/Booking/Meeting/Entity/Meeting'
    import MeetingLocationLink from '@/App/Booking/Meeting/Component/MeetingLocationLink.vue'

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        meeting: {
            type: Object as PropType<Meeting | null>,
            default: null,
        },
    })
</script>
